import { render, staticRenderFns } from "./TagsPerMonth.vue?vue&type=template&id=7253e85e"
import script from "./TagsPerMonth.vue?vue&type=script&lang=js"
export * from "./TagsPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports